export class RDAlert {
  type = 'danger';
  title = '';
  text = '';
}
